module.exports = __webpack_public_path__ + "media/assets/images/Sent_Validation_Mail-8c52803b8d82c241ff9f0fed3b4b0e5f.svg";